import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { apiService, Article } from '../services/api';
import ArticleCard from '../components/ArticleCard';
import colors from '../theme/colors';

const HomeContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  background-color: ${colors.lightGray};
  min-height: calc(100vh - 200px);
`;

const ArticlesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-bottom: 2rem;
`;

const LoadingMessage = styled.div`
  text-align: center;
  padding: 3rem;
  font-size: 1.1rem;
  color: ${colors.textGray};
`;

const ErrorMessage = styled.div`
  text-align: center;
  padding: 3rem;
  color: ${colors.mainOrange};
  background-color: ${colors.goldGrey};
  border: 2px solid ${colors.mainOrange};
  border-radius: 8px;
  margin: 2rem 0;
`;

const Home: React.FC = () => {
  const [articles, setArticles] = useState<Article[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        setLoading(true);
        const response = await apiService.getArticles();
        setArticles(response.data);
        setError(null);
      } catch (err) {
        setError('Не вдалося завантажити статті. Перевірте доступність API.');
      } finally {
        setLoading(false);
      }
    };

    fetchArticles();
  }, []);

  if (loading) {
    return (
      <HomeContainer>
        <LoadingMessage>Завантаження статей...</LoadingMessage>
      </HomeContainer>
    );
  }

  if (error) {
    return (
      <HomeContainer>
        <ErrorMessage>{error}</ErrorMessage>
      </HomeContainer>
    );
  }

  return (
    <HomeContainer>
      {articles.length === 0 ? (
        <LoadingMessage>Статей не знайдено. Додайте контент у Strapi адмінці.</LoadingMessage>
      ) : (
        <ArticlesGrid>
          {articles.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </ArticlesGrid>
      )}
    </HomeContainer>
  );
};

export default Home;
